const initialState = [
  {
    id: 1,
    text: "Learn redux",
    completed: false,
  },
  {
    id: 2,
    text: "Learn react",
    completed: false,
    color: "red",
  },
];

export default initialState;
